<template>
    <div
        v-if="componentName !== ''"
        class="left-slot"
    >
        <keep-alive>
            <component
                :is="componentName"
                :sub-topic="subTopic"
            />
        </keep-alive>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-facing-decorator"
    import PageWhitelistUtils from "@/helpers/pageWhitelistUtils"
    import Etusivu from "@/views/Etusivu.vue"
    import LaajakaistaJaPuhelin from "@/views/Viestinta/LaajakaistaJaPuhelin/LaajakaistaJaPuhelin.vue"
    import Posti from "@/views/Viestinta/Posti/Posti.vue"
    import TVJaRadio from "@/views/Viestinta/TVJaRadio/TVJaRadio.vue"
    import ViatJaHairiot from "@/views/Viestinta/ViatJaHairiot/ViatJaHairiot.vue"
    import Tieliikenne from "@/views/Liikenne/Tieliikenne/Tieliikenne.vue"
    import Vesiliikenne from "@/views/Liikenne/Vesiliikenne/Vesiliikenne.vue"
    import Infokartat from "@/views/Infokartat/Infokartat.vue"
    import Radiomikrofonitaajuudet from "@/views/Viestinta/Radiomikrofonitaajuudet/Radiomikrofonitaajuudet.vue"
    import Bittimittari from "@/views/Viestinta/Bittimittari/Bittimittari.vue"

    const TYPE_MAPPING = {
        Liikenne: "Liikenne",
        Viestinta: "Viestinta"
    }

    @Component({
        components: {
            Etusivu,
            LaajakaistaJaPuhelin,
            Posti,
            TVJaRadio,
            Tieliikenne,
            ViatJaHairiot,
            Vesiliikenne,
            Infokartat,
            Radiomikrofonitaajuudet,
            Bittimittari
        }
    })
    export default class LeftSlotTemplate extends Vue {
        @Prop({ type: String, default: "" }) pageName!: string
        @Prop({ type: String, default: "" }) typeName!: string
        @Prop({ type: String }) subTopic!: string
        @Prop({ type: Boolean, default: true }) whitelistSubjects!: boolean

        get componentName(): string {
            const pageWhitelistUtils = new PageWhitelistUtils()

            if (!TYPE_MAPPING[this.typeName] && this.typeName !== "") {
                // Jos typenamea ei löydy, asetetaan tyhjä, jolloin ei renderöidä
                this.$emit("pageNotfound")
                return ""
            }
            if (this.subTopic && (this.pageName !== "Infokartat" && this.pageName !== "LaajakaistaJaPuhelin" && this.pageName !== "Posti")) {
                // Tarkistetaan löytyykö subTopic whitelistalta
                if (this.whitelistSubjects
                    && pageWhitelistUtils.isMenuOnWhiteList(this.pageName)
                    && !pageWhitelistUtils.isSubjectOnWhiteList(this.subTopic)) {
                    // Jos subTopic annettu mutta ei löydy, asetetaan tyhjä, jolloin ei renderöidä
                    this.$emit("pageNotfound")
                    return ""
                }
            }
            if (pageWhitelistUtils.isMenuOnWhiteList(this.pageName) || this.pageName === "Etusivu") {
                return this.pageName
            }
            else {
                // Jos pagenamea ei löydy, asetetaan tyhjä, jolloin ei renderöidä
                this.$emit("pageNotfound")
                return ""
            }
        }
    }
</script>

<style scoped>
    .left-slot {
        padding: 1rem 1.25rem;
    }
</style>
